import {BaseWrapper} from '../../../allkey/framework/parameters/BaseWrapper';
import {BasicScenario} from '../../../allkey/framework/parameters/BasicScenario';
import {Feature} from '../message/Feature';
import {FeatureCriteria} from './FeatureCriteria';

export class FeatureWrapper extends BaseWrapper<Feature, FeatureCriteria, BasicScenario>  {}

